import AdminApi from '../../services/api'
import session from "../../services/session";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";
import swal from "sweetalert2";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            faqs: [],
            openFaqIds: [],
            showForm: false,
            isLoading: false,
            isSaving: false,
            errorMessage: '',
            form: buildEmptyForm()
        }
    },
    methods: {
        loadFaqs: loadFaqs,
        goBack: goBack,
        buildQuery: buildQuery,
        canManageFaq: canManageFaq,
        toggleFaq: toggleFaq,
        isFaqOpen: isFaqOpen,
        startAdd: startAdd,
        editFaq: editFaq,
        cancelForm: cancelForm,
        saveFaq: saveFaq,
        toggleActive: toggleActive,
        confirmDelete: confirmDelete,
        isFormValid: isFormValid
    },
    beforeMount() {
        if (!['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_TRAINER'].includes(session.getRole())) {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.loadFaqs();
    }
}

function buildEmptyForm() {
    return {
        id: null,
        question: '',
        answer: '',
        orderNumber: null,
        active: true
    };
}

function loadFaqs() {
    this.isLoading = true;
    this.errorMessage = '';
    AdminApiService.getFaqList()
        .then((response) => {
            this.faqs = response.data != null ? response.data : [];
            this.openFaqIds = [];
        })
        .catch(error => {
            this.errorMessage = getErrorMessage(error);
        })
        .finally(() => {
            this.isLoading = false;
        })
}

function goBack() {
    let target = this.$route.query.back === 'admin' ? '/admin-chat' : '/user-chat';
    this.$router.push({
        path: target,
        query: this.buildQuery({})
    });
}

function buildQuery(extraQuery) {
    let query = Object.assign({}, extraQuery);
    if (this.$route.query.programToken != null) {
        query.programToken = this.$route.query.programToken;
    }
    if (this.$route.query.locale != null) {
        query.locale = this.$route.query.locale;
    }
    return query;
}

function canManageFaq() {
    return ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_TRAINER'].includes(session.getRole());
}

function toggleFaq(id) {
    if (this.isFaqOpen(id)) {
        this.openFaqIds = this.openFaqIds.filter(item => item !== id);
    } else {
        this.openFaqIds.push(id);
    }
}

function isFaqOpen(id) {
    return this.openFaqIds.includes(id);
}

function startAdd() {
    this.form = buildEmptyForm();
    this.showForm = true;
}

function editFaq(faq) {
    this.form = {
        id: faq.id,
        question: faq.question,
        answer: faq.answer,
        orderNumber: faq.orderNumber,
        active: faq.active == null ? true : faq.active
    };
    this.showForm = true;
}

function cancelForm() {
    this.form = buildEmptyForm();
    this.showForm = false;
}

function saveFaq() {
    if (!this.isFormValid() || this.isSaving) return;
    this.isSaving = true;
    this.errorMessage = '';
    let model = {
        question: this.form.question,
        answer: this.form.answer,
        active: this.form.active
    };
    if (this.form.id != null) {
        model.id = this.form.id;
    }
    if (this.form.orderNumber !== null && this.form.orderNumber !== '') {
        model.orderNumber = Number(this.form.orderNumber);
    }
    let request = model.id != null ? AdminApiService.updateFaq(model) : AdminApiService.createFaq(model);
    request
        .then(() => {
            this.cancelForm();
            this.loadFaqs();
        })
        .catch(error => {
            this.errorMessage = getErrorMessage(error);
        })
        .finally(() => {
            this.isSaving = false;
        })
}

function toggleActive(faq) {
    let model = {
        id: faq.id,
        question: faq.question,
        answer: faq.answer,
        orderNumber: faq.orderNumber,
        active: !faq.active
    };
    AdminApiService.updateFaq(model)
        .then(() => {
            this.loadFaqs();
        })
        .catch(error => {
            this.errorMessage = getErrorMessage(error);
        })
}

function confirmDelete(faq) {
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_faq_delete_confirm'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then((result) => {
        if (result != null && (result.dismiss != null || result.value === false)) return;
        AdminApiService.deleteFaq(faq.id)
            .then(() => {
                this.loadFaqs();
            })
            .catch(error => {
                this.errorMessage = getErrorMessage(error);
            })
    }).catch(() => {});
}

function isFormValid() {
    return (this.form.question || '').trim().length > 0 && (this.form.answer || '').trim().length > 0;
}

function getErrorMessage(error) {
    if (error != null && error.data != null && error.data.localized_error_message != null) {
        return error.data.localized_error_message;
    }
    return LocService.t('label_chat_load_error');
}



// WEBPACK FOOTER //
// ./src/components/Chat/ChatFaq.js